<template>
  <PullRefresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh">
    <div
      :class="`${$style.templatePage} ${hiddenTitle ? $style.hiddenTitle : ''}`"
    >
      <header>
        <div @click="closePage">
          <i class="iconfont yw-xiangzuo"></i>
        </div>
        <span>{{ pageTitle }}</span>
      </header>
      <div v-if="isWeChat" :class="$style.dialogMask" @click="isWeChat = false">
        <img
          :src="`${cdnLink}/box_subscribe/wxGuide.jpg`"
          :class="$style.wxGuide"
          loading="lazy"
        />
      </div>

      <div :class="$style.templateContent">
        <img :class="$style.image" :src="actPic" />
        <img
          :class="`${$style.btn} btCopyFissionDeviceCodeCdk`"
          :src="btPic"
          @click="onClick"
        />
      </div>
    </div>
  </PullRefresh>
</template>

<script>
import { inithandler } from "@/bridge/jsBridge";
import {
  onGoBack,
  setPageTitle,
  toLogin,
  getUserInfo,
  signInEventTrack,
} from "@/bridge/AppJsBridge";
import { PullRefresh } from "vant";
import {
  checkIsWxBrowser,
  pageLoseTips,
  getCookie,
  decryptDes,
  encryptDes,
} from "@/libs/utils";
import {
  sendPoint,
  getBtTemplateApi,
  sendDeviceCodeApi,
} from "@/apis/btBoxActivity";
import { queue } from "../../libs/queue.request";
import { CDN_URL_1 } from "@/config";
import { v1 as uuidv1 } from "uuid";
import Clipboard from "clipboard";

export default {
  name: "",
  components: { PullRefresh },
  data() {
    return {
      cdnLink: CDN_URL_1,
      cookie: "",
      hiddenTitle: true,
      isLoading: false,
      actId: "",
      pageTitle: "活动",
      actPic: "",
      btPic: "",
      routePath: "",
      hasToken: false,
      pageType: 1, // 默认为类型1-通用活动 2-邀请分享活动
      isWeChat: false,
      decryptUid: "", //用户id
      decryptUsername: "", // 用户名
      deviceCode: "", // 设备号
      reqQueue: queue(),
    };
  },
  created() {
    // 页面初始化
    inithandler();
    // 获取设备信息
    this.reqQueue.create();
    this.initPageData();
    try {
      signInEventTrack((data) => {
        this.cookie = JSON.parse(data);
      });
    } catch (error) {
      console.log("🚀 ~ file: signInEventTrack", error);
    }
  },
  watch: {
    cookie(value, oldValue) {
      if (!oldValue && value && !getCookie()) {
        this.reqQueue.run(value);
      }
    },
  },

  activated() {},
  methods: {
    // 判断是否需要隐藏标题拦
    checkHasPageTitle() {
      if (checkIsWxBrowser()) {
        this.hiddenTitle = true;
      }
    },

    // 获取cookie、缓存等携带的用户信息数据
    initPageData() {
      const { history } = this.$router;
      const { id, uid, userName } = history.current.query;
      let type = 1;
      if (!id) {
        pageLoseTips(this.$toast);
        return;
      }

      let idAndType = id.split('_');
      let typeStr = idAndType[1];
      this.actId = idAndType[0];
      if (typeStr && typeStr.split('=')[1]) {
        type = typeStr.split('=')[1];
        this.pageType = typeStr.split('=')[1];
      }else{
        pageLoseTips(this.$toast);
        return;
      }

      this.checkHasPageTitle();
      const pageCookie = getCookie();
      if (pageCookie) {
        for (const key in pageCookie) {
          if (
            Object.hasOwnProperty.call(pageCookie, key) &&
            pageCookie[key] === "null"
          ) {
            delete pageCookie[key];
          }
        }
        this.cookie = pageCookie;
      }
      // 通用活动
      if (type == 1) {
        // 获取token
        this.getAppToken();
      }
      // 裂变活动分享页面
      if (type == 2) {
        document.title = '你的好友邀请你并肩作战';
        // 解密
        try {
          this.decryptUid = decryptDes("btfisshj", "btfisshj", uid);
          this.decryptUsername = decryptDes("btfisshj", "btfisshj", userName);
        } catch (error) {
          console.log("分享页 error:", error);
        }
        // 生成设备号
        this.deviceCode = uuidv1();
        this.getTemplateInfo(this.actId);
      }
    },

    getAppToken() {
      if (getCookie("token")) {
        localStorage.setItem("token", getCookie("token"));
        this.getTemplateInfo(this.actId);
      } else {
        getUserInfo((userInfo) => {
          let Info = JSON.parse(userInfo);
          if (Info.token) {
            this.hasToken = true;
            localStorage.setItem("token", Info.token);
            this.getTemplateInfo(this.actId);
          } else {
            toLogin("/loginKey/LoginByKeyPhoneActivity");
          }
        });
      }
    },

    // 上报设备标识
    async sendDeviceCode() {
      const params = {
        uniqueCode: this.deviceCode,
        uid: Number(this.decryptUid),
      };
      const encryptParams = encryptDes("btfisshj", "btfisshj", params);
      let formData = new FormData();
      formData.append("data", encryptParams);
      try {
        await sendDeviceCodeApi(formData);
      } catch (error) {
        console.log("error:", error);
      }
    },

    getTemplateInfo(id) {
      getBtTemplateApi({ id })
        .then((res) => {
          const { actPic, btPic, routePath, title } = res.data;
          this.actPic = actPic;
          this.btPic = btPic;
          this.routePath = routePath;
          this.pageTitle = title;
          this.hasToken = true;
          setPageTitle(title);
          let event = "pic_activity_page";
          if (this.pageType == 2) {
            event = "invite_user_share_page";
          }
          this.eventTrack({
            event: event,
            event_field: JSON.stringify({
              activity_name: this.pageTitle,
              activity_id: this.actId,
              type: this.pageType,
              ...this.getTheQuery(),
            }),
          });
        })
        .catch((error) => {
          //
        });
    },

    // 250825: 透传转游策略参数
    getTheQuery () {
      const data = {}
      const source = this.$route.query.id
      if (source && source.includes('=')) {  
        const querys = source.split('_')
        const [a, b, ...rest] = querys || []
        if (rest && rest.length) {
          rest.forEach(v => {
            if (!v.includes('=')) return
            const [key, value] = v.split('=')
            data[key] = value
          })
        }
      }
      return data
    },

    // 数据上报
    eventTrack(data) {
      // this.$toast(data.event);
      const params = {
        ...data,
      };
      if (!this.cookie && this.pageType == 1) {
        console.log("数据上报异常", data.event, "转为补充数据上报");
        this.reqQueue.add(sendPoint, params);
        return;
      }
      console.log("正常数据上报", data.event);
      sendPoint({
        ...this.cookie,
        ...data,
      }).catch((err) => console.log(err));
    },

    // 关闭页面
    closePage() {
      onGoBack();
    },

    // 下拉刷新
    async onRefresh() {
      await this.initPageData();
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    onCopy() {
      let that = this;
      let clipboard = new Clipboard(".btCopyFissionDeviceCodeCdk", {
        text: function (trigger) {
          //返回字符串
          return `Bt_inviteCode_${that.deviceCode}_${that.decryptUsername}`;
        },
      });
      clipboard.on("success", (e) => {
        //复制成功
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        //复制失败
        clipboard.destroy();
      });
    },

    onClick() {
      if (this.pageType == 2) {
        if (checkIsWxBrowser()) {
          this.isWeChat = true;
          return;
        }
        this.sendDeviceCode();
        this.onCopy();
      }

      if (!this.hasToken && this.pageType == 1) {
        toLogin("/loginKey/LoginByKeyPhoneActivity");
        return;
      }

      if (this.routePath) {
        setTimeout(() => {
          const querys = this.getTheQuery()
          const queryStr = Object.keys(querys).map(key => `${key}=${querys[key]}`).join('_')
          let url = this.routePath
          if (url.startsWith('wxbt://app/box-/main/game/GameDetailActivity')) {
            url = `${url}${queryStr.length ? '-' : ''}${queryStr}`
          }
          window.open(url, "_blank");
        }, 500);
      }

      if (this.actId) {
        let event = "pic_activity_gift_icon";
        let eventField = {
          activity_name: this.pageTitle,
          activity_id: this.actId,
          type: this.pageType,
        };
        if (this.pageType == 2) {
          eventField.code = this.deviceCode;
          event = "invite_user_share_page_download";
        }

        this.eventTrack({
          event: event,
          event_field: JSON.stringify(eventField),
        });
      }
    },
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style lang="scss" module>
.templatePage {
  width: 100%;
  height: 100%;
  max-width: 375px;
  margin: auto;
  padding-top: 50px;
  overflow: auto;

  .dialogMask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 99;

    > img {
      width: 100%;
    }
  }

  &.hiddenTitle {
    padding-top: 0px;
    > header {
      display: none;
    }
  }
  > header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    max-width: 375px;
    margin: auto;
    z-index: 3;
    background: #ffffff;
    color: #000000;
    font-size: 19px;
    padding: 14px 5px 14px 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div {
      font-weight: bold;
      position: absolute;
    }
    > span {
      font-size: 18px;
      font-weight: 700;
      margin: 0 auto;
    }
    :global {
      .iconfont {
        font-size: 22px;
        margin-right: 5px;
      }
    }
  }
  .templateContent {
    width: 100%;
    height: auto;
    .image {
      width: 100%;
    }

    .btn {
      width: 100%;
      position: fixed;
      bottom: 0px;
      left: 0;
      right: 0;
      margin: 0 auto;
    }
  }
}
</style>
